<template>
  <v-app>
    <v-main>
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-main>
    <pugin-dialog
      v-if="getPluginDialog"
      :title="getPluginDialog.title"
      :text="getPluginDialog.text"
      :color="getPluginDialog.color"
      @dismissed="onDismissed"
    ></pugin-dialog>
    <update-Snackbar />
    <snackbar-message />
    <info-dialog />
  </v-app>
</template>

<script>
import {mapGetters} from 'vuex'
const PluginDialog = () => import(/* webpackChunkName: "PluginDialog" */ '@/components/dialogs/PluginDialog.vue')
const SnackbarMessage = () =>
  import(/* webpackChunkName: "SnackbarMessage" */ '@/components/shared/SnackbarMessage.vue')
const InfoDialog = () => import(/* webpackChunkName: "InfoDialog" */ '@/components/dialogs/InfoDialog.vue')
const UpdateSnackbar = () => import(/* webpackChunkName: "InfoDialog" */ '@/components/snackbar/appUpdateSnackbar.vue')

export default {
  name: 'App',
  components: {
    'pugin-dialog': PluginDialog,
    'snackbar-message': SnackbarMessage,
    'info-dialog': InfoDialog,
    'update-Snackbar': UpdateSnackbar,
  },
  data: () => ({
    //
  }),
  computed: {
    ...mapGetters(['getPluginDialog']),
  },
  methods: {
    onDismissed() {
      this.$store.dispatch('clearAction')
    },
  },
}
// window.productHuntUpcoming = {
//   appId: 19607,
//   position: 'bottomLeft',
// }
// ;(function (doc, scr, src, a, b) {
//   a = doc.createElement(scr)
//   b = doc.getElementsByTagName(scr)[0]
//   a.async = true
//   a.src = src
//   b.parentNode.insertBefore(a, b)
// })(document, 'script', 'https://assets.producthunt.com/assets/upwigloader.js')
</script>
